module.exports = __webpack_public_path__ + "static/img/right-home-row-4.95c0c91a.png";